import React from "react";
import Notes from "../notes";
import Chatbot from "../chatbot";
import styles from "../DetailsTab.module.css";

/**
 * NotesAIPanel — inner section inside the merged right-column card.
 *
 * Combines the Notes list and the TOCA AI conversation in a single tabbed
 * area. The card chrome (shadow, radius, padding) is provided by the
 * parent `.rightCard` wrapper in DetailsTab; this component is a pure
 * tab switcher between existing <Notes /> and existing <Chatbot />.
 *
 * TOCA General Copilot is intentionally dropped here per the redesign
 * decision; the rendering is gated on hasChatbotAccess upstream.
 *
 * The active tab is controlled by the parent (DetailsTab) so external
 * actions — e.g. the CarePlan "Toca Copilot" dropdown — can switch to
 * the AI tab and mount <Chatbot /> before triggering the chat start.
 */
const NotesAIPanel = ({
  chatBotType,
  hasChatbotAccess,
  onNoteClick,
  notesIsOpen,
  notesOnClose,
  chatProps,
  activeTab,
  setActiveTab,
}) => {
  // Wrap everything in .notesAiWrap (gap: 0) so the active tab's
  // bottom edge sits flush against the Notes/Chatbot container — the
  // parent .cardSection's --space-row gap (16px) would otherwise show
  // as a white strip between the tabs and the panel.
  return (
    <div className={styles.notesAiWrap}>
      <div className={styles.notesAiTabsRow}>
        <div className={styles.panelTabs}>
          <button
            type="button"
            className={`${styles.panelTabBtn} ${
              activeTab === "notes" ? styles.active : ""
            }`}
            onClick={() => setActiveTab("notes")}
          >
            Notes
          </button>
          {hasChatbotAccess && (
            <button
              type="button"
              className={`${styles.panelTabBtn} ${
                activeTab === "ai" ? styles.active : ""
              }`}
              onClick={() => setActiveTab("ai")}
            >
              TOCA AI
            </button>
          )}
        </div>
      </div>

      {activeTab === "notes" && (
        <Notes
          chatBotType={chatBotType}
          isOpen={notesIsOpen}
          onClose={notesOnClose}
          onNoteClick={onNoteClick}
        />
      )}

      {activeTab === "ai" && hasChatbotAccess && (
        <Chatbot chatProps={chatProps} />
      )}
    </div>
  );
};

export default NotesAIPanel;
